import React from "react";
import { Box, Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import type { PendingStatus } from "../types";

interface PendingCircleActionsProps {
  circleId: string;
  acceptanceStatus: PendingStatus;
  canAddSelf?: boolean;
  onJoinCircle: (circleId: string) => void;
  onDecline: (circleId: string) => void;
}

export const PendingCircleActions: React.FC<PendingCircleActionsProps> = ({
  circleId,
  acceptanceStatus,
  canAddSelf,
  onJoinCircle,
  onDecline,
}) => {
  if (acceptanceStatus === "pending") {
    // If canAddSelf is false, user requested to join and is waiting for admin approval
    if (canAddSelf === false) {
      return (
        <Button
          size="small"
          variant="outlined"
          color="info"
          startIcon={<HourglassEmptyIcon fontSize="small" />}
          disabled
          sx={{ flex: 1, fontWeight: 600, fontSize: "0.82rem" }}
        >
          Awaiting Approval
        </Button>
      );
    }
    return (
      <Box sx={{ display: "flex", gap: 1 }}>
        <Button
          size="small"
          color="primary"
          variant="contained"
          onClick={() => onJoinCircle(circleId)}
        >
          Join
        </Button>
        <Button
          size="small"
          color="primary"
          variant="outlined"
          onClick={() => onDecline(circleId)}
        >
          Decline
        </Button>
      </Box>
    );
  }

  if (acceptanceStatus === "accepted") {
    return (
      <Button
        size="small"
        variant="outlined"
        color="success"
        startIcon={<CheckCircleIcon fontSize="small" />}
        disabled
        sx={{ flex: 1, fontWeight: 600, fontSize: "0.82rem" }}
      >
        Accepted
      </Button>
    );
  }

  if (acceptanceStatus === "rejected") {
    return (
      <Button
        size="small"
        variant="outlined"
        color="warning"
        startIcon={<CheckCircleIcon fontSize="small" />}
        disabled
        sx={{ flex: 1, fontWeight: 600, fontSize: "0.82rem" }}
      >
        Rejected
      </Button>
    );
  }

  return null;
};

